export const LOGO = "/img/logo/hospital.png";
export const EYE_MENU = "/img/logo/eye_menu.png";
export const CHART_1 = "/img/logo/chart_1.png";
export const CHART_2 = "/img/logo/chart_2.png";
export const CHART_3 = "/img/logo/chart_3.png";
export const CHART_4 = "/img/logo/chart_4.png";
export const CHART_5 = "/img/logo/chart_5.png";
export const CHART_6 = "/img/logo/chart_6.png";
